import { render, staticRenderFns } from "./alarmCenter.vue?vue&type=template&id=3ea623c4&scoped=true"
import script from "./alarmCenter.vue?vue&type=script&lang=js"
export * from "./alarmCenter.vue?vue&type=script&lang=js"
import style0 from "./alarmCenter.vue?vue&type=style&index=0&id=3ea623c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea623c4",
  null
  
)

export default component.exports